module.exports = __webpack_public_path__ + "img/gley.98a1be37.svg";